import { render, staticRenderFns } from "./datalimitesocilicitacaoafastamento.vue?vue&type=template&id=17ce8c92&"
import script from "./datalimitesocilicitacaoafastamento.vue?vue&type=script&lang=js&"
export * from "./datalimitesocilicitacaoafastamento.vue?vue&type=script&lang=js&"
import style0 from "./datalimitesocilicitacaoafastamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports